import { FetchResult, gql } from '@apollo/client';
import { SendFiberRetargetingDataInput, SendFiberRetargetingDataPayload } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';

export type sendFiberRetargetingResponse = FetchResult<{ sendFiberRetargetingData: SendFiberRetargetingDataPayload }>;

const SEND_FIBER_RETARGETING_DATA = gql`
  mutation sendFiberRetargetingData($input: sendFiberRetargetingDataInput!) {
    sendFiberRetargetingData(input: $input) {
      success
    }
  }
`;

export async function sendFiberRetargetingDataAsync(
  data: SendFiberRetargetingDataInput,
): Promise<sendFiberRetargetingResponse> {
  const { fiberWaitlist, customerRelationshipId, addressId, goLiveForecastDate } = data;
  return await client.mutate<{ sendFiberRetargetingData: SendFiberRetargetingDataPayload }>({
    mutation: SEND_FIBER_RETARGETING_DATA,
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        customerRelationshipId,
        fiberWaitlist,
        addressId,
        goLiveForecastDate,
      },
    },
  });
}
